export default __webpack_public_path__ + "images/0e26c9b5ec9107f3a2de419919db0dc1.png";